const init = () => {
    const ctaNew2 = $('.cta-new2');

    if (ctaNew2.length > 0) {
        const $window = $(window);
        const pos = ctaNew2.offset().top;

        $window.on('scroll load', () => {
            const scrollY = $window.scrollTop();
            const parent = ctaNew2.parent();

            if (scrollY >= pos) {
                // Adjust parent height so the content doesn't jump when the cta it sticks
                parent.css('height', parent.height());
                ctaNew2.addClass('cta-new2--stuck');
            } else {
                ctaNew2.removeClass('cta-new2--stuck');
                // Reset parent height so content doesn't jump
                parent.css('height', '');
            }
        });
    }
};

export { init };
